import { render, staticRenderFns } from "./AClientsTab.vue?vue&type=template&id=4754ffaf&"
import script from "./AClientsTab.vue?vue&type=script&lang=js&"
export * from "./AClientsTab.vue?vue&type=script&lang=js&"
import style0 from "./AClientsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports